import { css } from 'lit';

export const style = css`
  .text-md {
    line-height: 1.55;
    font-size: var(--kb-fx-14);
    font-family: var(--kb-font--family--conversation);
    color: var(--kb-clr--black-1);
    font-weight: 300;
    margin: 0 auto;
    max-width: 100%;
    padding: var(--kb-fx-4);
  }

  .text-md * {
    word-break: break-word;
    hyphens: auto;
  }

  .text-md pre {
    padding: var(--kb-fx-8);
    line-height: 1.25;
    overflow-x: scroll;
  }

  .text-md a,
  .text-md a:visited {
    color: var(--kb-clr--blue-5);
    font-weight: 400;
  }

  .text-md a::before {
    content: '→';
    margin-right: var(--kb-fx-2);
  }

  .text-md a:hover,
  .text-md a:focus,
  .text-md a:active {
    color: var(--kb-clr--blue-2);
  }

  .text-md.blue {
    font-weight: 400;
  }

  .text-md p:not(:last-of-type) {
    margin-bottom: 0.4rem;
  }

  .text-md h1,
  .text-md h2,
  .text-md h3,
  .text-md h4 {
    margin: 1.414rem 0 0.5rem;
    font-weight: inherit;
    line-height: 1.42;
  }

  .text-md h1 {
    margin-top: 0;
    font-size: 3.998rem;
  }

  .text-md h2 {
    font-size: 2.827rem;
  }

  .text-md h3 {
    font-size: 1.999rem;
  }

  .text-md h4 {
    font-size: 1.414rem;
  }

  .text-md h5 {
    font-size: 1.121rem;
  }

  .text-md h6 {
    font-size: 0.88rem;
  }

  .text-md small {
    font-size: 0.707em;
  }

  .text-md img,
  .text-md canvas,
  .text-md iframe,
  .text-md video,
  .text-md svg,
  .text-md select,
  .text-md textarea {
    max-width: 100%;
  }

  .text-md h1,
  .text-md h2,
  .text-md h3 {
    border-bottom: var(--kb-fx-2) solid var(--kb-clr--white-1);
    padding-bottom: var(--kb-fx-8);
    margin-bottom: 1.15rem;
  }

  .text-md blockquote {
    border-left: var(--kb-fx-8) solid var(--kb-clr--white-1);
    padding: var(--kb-fx-16);
  }

  .text-md pre,
  .text-md code {
    background-color: var(--kb-clr--white-1);
  }

  .text-md table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    border: var(--kb-tile--border);
  }

  .text-md th,
  .text-md td {
    padding: var(--kb-fx-4);
  }

  .text-md ul {
    margin: 0;
    padding: 0;
    margin-left: 0.5rem;
    list-style-position: inside;
  }
`;
